import { RiBarChartLine } from '@remixicon/react';

import { isChartBlockTool } from '@spotify/confidence-core-react';
import { createToolExtension } from '@spotify/plugin-confidence-chat-react';

import { confidenceChatPlugin } from '../plugin';

export const CreateChartBlockToolExtension = confidenceChatPlugin.provide(
  createToolExtension({
    id: 'create-chart-block',
    predicate: isChartBlockTool,
    icon: RiBarChartLine,
    display: 'grouped',
    render: () => null,
    renderTool: () => null,
  }),
);
